import React from 'react';
import ProtocolForm from './ProtocolForm.js';

export const AddProtocol = ({ onSuccess, planType }) => {
  return (
    <div className="AddProtocol">
      <ProtocolForm
        mode="add"
        planType={planType}
        onSuccess={onSuccess}
      />
    </div>
  );
}

export default AddProtocol;
